import { coreTagsByIdDeleteAsyncSlice } from './delete';
import { coreTagsByIdPutAsyncSlice } from './put';

export const { requestDeleteCoreTagsById, resetDeleteCoreTagsById } = coreTagsByIdDeleteAsyncSlice.asyncActionCreators;
export const { requestPutCoreTagsById, resetPutCoreTagsById } = coreTagsByIdPutAsyncSlice.asyncActionCreators;
